module.exports = "\r\n\r\n<router-outlet></router-outlet>\r\n"